(function () {
  "use strict";

  const bobbyPageInstances = new WeakMap();
  const mobileMedia = window.matchMedia("(max-width: 767px)");

  /* ========================================================================
   * Hero Section - Start
   * Static visual section; no runtime behavior is required.
   * ======================================================================== */
  /* Hero Section - End ===================================================== */

  /* ========================================================================
   * Bobby Story Section - Start
   * Static visual section; no runtime behavior is required.
   * ======================================================================== */
  /* Bobby Story Section - End ============================================== */

  /* ========================================================================
   * Weather Protection Section - Start
   * Static visual section; no runtime behavior is required.
   * ======================================================================== */
  /* Weather Protection Section - End ====================================== */

  /* ========================================================================
   * Shared Carousel - Start
   * Accessible scroll-snap controller used by the visual content carousels.
   * ======================================================================== */

  function createBobbyCarousel(carousel, abortSignal) {
    const track = carousel.querySelector("[data-bobby-carousel-track]");
    const slides = Array.from(
      carousel.querySelectorAll("[data-bobby-carousel-slide]"),
    );
    const previousButton = carousel.querySelector("[data-bobby-carousel-prev]");
    const nextButton = carousel.querySelector("[data-bobby-carousel-next]");
    const dotsContainer = carousel.querySelector("[data-bobby-carousel-dots]");
    const mobileOnly = carousel.hasAttribute("data-bobby-mobile-only");

    if (!track || slides.length < 2) return null;

    let activeIndex = 0;
    let updateFrame = 0;
    const dots = [];

    function isEnabled() {
      return !mobileOnly || mobileMedia.matches;
    }

    function getNearestSlideIndex() {
      const trackLeft = track.getBoundingClientRect().left;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function renderActiveState(index) {
      activeIndex = index;
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle("is-active", dotIndex === activeIndex);
      });
    }

    function updateActiveState() {
      window.cancelAnimationFrame(updateFrame);
      updateFrame = window.requestAnimationFrame(() => {
        updateFrame = 0;
        if (!isEnabled()) return;
        renderActiveState(getNearestSlideIndex());
      });
    }

    function goToSlide(index, behavior) {
      if (!isEnabled()) return;
      const normalizedIndex = (index + slides.length) % slides.length;
      track.scrollTo({
        left: slides[normalizedIndex].offsetLeft - track.offsetLeft,
        behavior: behavior || "smooth",
      });
      renderActiveState(normalizedIndex);
    }

    if (dotsContainer) {
      slides.forEach((_, index) => {
        const dot = document.createElement("span");
        dot.className = "bobby-page__carousel-dot";
        dot.setAttribute("data-bobby-carousel-dot", "");
        dotsContainer.append(dot);
        dots.push(dot);
      });
    }

    previousButton?.addEventListener(
      "click",
      () => goToSlide(activeIndex - 1),
      { signal: abortSignal },
    );
    nextButton?.addEventListener(
      "click",
      () => goToSlide(activeIndex + 1),
      { signal: abortSignal },
    );
    track.addEventListener("scroll", updateActiveState, {
      passive: true,
      signal: abortSignal,
    });

    renderActiveState(0);

    return {
      refresh() {
        if (!isEnabled()) {
          track.scrollLeft = 0;
          renderActiveState(0);
          return;
        }
        goToSlide(activeIndex, "auto");
      },
      destroy() {
        window.cancelAnimationFrame(updateFrame);
      },
    };
  }

  /* ========================================================================
   * Shared Carousel - End
   * ======================================================================== */

  /* ========================================================================
   * Tough Reinforcement Section - Start
   * GSAP marquee on mobile; desktop remains a static three-column triptych.
   * ======================================================================== */

  function createToughMarquee(marquee, abortSignal) {
    const track = marquee.querySelector(".bobby-page__tough-track");
    const originalSlides = Array.from(
      track?.querySelectorAll(".bobby-page__tough-slide") || [],
    );

    if (!track || originalSlides.length < 2 || !window.gsap) return null;

    originalSlides.forEach((slide) => {
      slide.querySelectorAll("img").forEach((image) => {
        image.draggable = false;
      });
    });

    const clonedSlides = originalSlides.map((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add("bobby-page__tough-slide--clone");
      clone.setAttribute("aria-hidden", "true");
      clone.querySelectorAll("img").forEach((image) => {
        image.draggable = false;
      });
      track.append(clone);
      return clone;
    });

    let marqueeTween = null;
    let retryTimer = 0;

    function buildMarquee() {
      window.clearTimeout(retryTimer);
      marqueeTween?.kill();
      window.gsap.set(track, { x: 0 });

      if (!mobileMedia.matches) return;

      const cycleWidth = clonedSlides[0].offsetLeft - originalSlides[0].offsetLeft;

      if (cycleWidth <= 0) {
        retryTimer = window.setTimeout(buildMarquee, 100);
        return;
      }

      marqueeTween = window.gsap.to(track, {
        x: -cycleWidth,
        duration: cycleWidth / 55,
        ease: "none",
        repeat: -1,
      });
    }

    marquee.addEventListener("dragstart", (event) => event.preventDefault(), {
      signal: abortSignal,
    });

    window.requestAnimationFrame(buildMarquee);

    return {
      refresh: buildMarquee,
      destroy() {
        window.clearTimeout(retryTimer);
        marqueeTween?.kill();
        clonedSlides.forEach((slide) => slide.remove());
        window.gsap.set(track, { clearProps: "transform" });
      },
    };
  }

  function initToughMarquee(root, abortSignal) {
    const marquee = root.querySelector(
      ".bobby-page__tough [data-bobby-tough-marquee]",
    );
    return marquee ? createToughMarquee(marquee, abortSignal) : null;
  }

  /* ========================================================================
   * Tough Reinforcement Section - End
   * ======================================================================== */

  /* ========================================================================
   * Easy On Section - Start
   * Desktop uses the single wide zipper detail.
   * ======================================================================== */
  /* ========================================================================
   * Easy On Section - End
   * ======================================================================== */

  /* ========================================================================
   * Full Coverage Section - Start
   * Static desktop visual section; no runtime behavior is required.
   * ======================================================================== */
  /* Full Coverage Section - End ============================================ */

  /* ========================================================================
   * Mobile Feature Carousel - Start
   * Two full feature panels autoplay and remain manually swipeable.
   * ======================================================================== */

  function createMobileFeatureCarousel(carousel, abortSignal) {
    const track = carousel.querySelector("[data-bobby-mobile-features-track]");
    const slides = Array.from(
      carousel.querySelectorAll("[data-bobby-mobile-feature-slide]"),
    );
    const indicators = Array.from(
      carousel.querySelectorAll("[data-bobby-mobile-feature-indicator]"),
    );

    if (!track || slides.length !== 2) return null;

    slides.forEach((slide) => {
      slide.querySelectorAll("img").forEach((image) => {
        image.draggable = false;
      });
    });

    let activeIndex = 0;
    let autoplayTimer = 0;
    let scrollTimer = 0;
    let updateFrame = 0;
    let dragStartX = 0;
    let dragStartScrollLeft = 0;
    let dragStartIndex = 0;
    let isMouseDragging = false;

    function render(index) {
      activeIndex = index;
      indicators.forEach((indicator, indicatorIndex) => {
        const isActive = indicatorIndex === activeIndex;
        indicator.classList.toggle("is-active", isActive);
        indicator.setAttribute("aria-current", String(isActive));
      });
    }

    function stopAutoplay() {
      window.clearTimeout(autoplayTimer);
      autoplayTimer = 0;
    }

    function goToSlide(index, behavior) {
      const normalizedIndex = (index + slides.length) % slides.length;
      const targetLeft =
        track.scrollLeft +
        slides[normalizedIndex].getBoundingClientRect().left -
        track.getBoundingClientRect().left;
      track.scrollTo({
        left: targetLeft,
        behavior: behavior || "smooth",
      });
      if (behavior === "auto" || Math.abs(targetLeft - track.scrollLeft) < 1) {
        render(normalizedIndex);
      }
    }

    function getNearestSlideIndex() {
      const trackLeft = track.getBoundingClientRect().left;
      return slides.reduce((nearest, slide, index) => {
        const currentDistance = Math.abs(
          slide.getBoundingClientRect().left - trackLeft,
        );
        const nearestDistance = Math.abs(
          slides[nearest].getBoundingClientRect().left - trackLeft,
        );
        return currentDistance < nearestDistance ? index : nearest;
      }, 0);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!mobileMedia.matches || document.hidden || isMouseDragging) return;

      autoplayTimer = window.setTimeout(() => {
        goToSlide(activeIndex + 1);
        startAutoplay();
      }, 4500);
    }

    function updateFromScroll() {
      window.cancelAnimationFrame(updateFrame);
      updateFrame = window.requestAnimationFrame(() => {
        updateFrame = 0;
        if (!mobileMedia.matches) return;

        render(getNearestSlideIndex());
      });

      window.clearTimeout(scrollTimer);
      if (!isMouseDragging) {
        scrollTimer = window.setTimeout(startAutoplay, 220);
      }
    }

    indicators.forEach((indicator, index) => {
      indicator.addEventListener(
        "click",
        () => {
          stopAutoplay();
          goToSlide(index);
          startAutoplay();
        },
        { signal: abortSignal },
      );
    });

    track.addEventListener("scroll", updateFromScroll, {
      passive: true,
      signal: abortSignal,
    });
    track.addEventListener(
      "pointerdown",
      (event) => {
        stopAutoplay();
        if (event.pointerType !== "mouse" || event.button !== 0) return;

        isMouseDragging = true;
        window.clearTimeout(scrollTimer);
        dragStartX = event.clientX;
        dragStartScrollLeft = track.scrollLeft;
        dragStartIndex = activeIndex;
        track.classList.add("is-dragging");
        track.setPointerCapture(event.pointerId);
      },
      { signal: abortSignal },
    );
    track.addEventListener(
      "pointermove",
      (event) => {
        if (!isMouseDragging) return;
        event.preventDefault();
        track.scrollLeft = dragStartScrollLeft - (event.clientX - dragStartX);
      },
      { signal: abortSignal },
    );

    function finishMouseDrag(event) {
      if (!isMouseDragging) {
        startAutoplay();
        return;
      }

      isMouseDragging = false;
      track.classList.remove("is-dragging");
      if (track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }
      const dragDistance = event.clientX - dragStartX;
      if (Math.abs(dragDistance) >= 40) {
        goToSlide(dragStartIndex + (dragDistance < 0 ? 1 : -1));
      } else {
        goToSlide(dragStartIndex);
      }
      startAutoplay();
    }

    track.addEventListener("pointerup", finishMouseDrag, {
      signal: abortSignal,
    });
    track.addEventListener("pointercancel", finishMouseDrag, {
      signal: abortSignal,
    });
    track.addEventListener("dragstart", (event) => event.preventDefault(), {
      signal: abortSignal,
    });
    document.addEventListener("visibilitychange", startAutoplay, {
      signal: abortSignal,
    });

    render(0);
    startAutoplay();

    return {
      refresh() {
        if (!mobileMedia.matches) {
          stopAutoplay();
          track.scrollLeft = 0;
          render(0);
          return;
        }
        goToSlide(activeIndex, "auto");
        startAutoplay();
      },
      destroy() {
        stopAutoplay();
        window.clearTimeout(scrollTimer);
        window.cancelAnimationFrame(updateFrame);
        track.classList.remove("is-dragging");
      },
    };
  }

  function initMobileFeatureCarousel(root, abortSignal) {
    const carousel = root.querySelector("[data-bobby-mobile-features]");
    return carousel
      ? createMobileFeatureCarousel(carousel, abortSignal)
      : null;
  }

  /* ========================================================================
   * Mobile Feature Carousel - End
   * ======================================================================== */

  /* ========================================================================
   * Product Details Section - Start
   * Static visual section; no runtime behavior is required.
   * ======================================================================== */
  /* Product Details Section - End ========================================== */

  /* ========================================================================
   * Small Details Section - Start
   * GSAP drives a seamless marquee; pointer hover temporarily slows it down.
   * ======================================================================== */

  function createDetailsMarquee(marquee, abortSignal) {
    const track = marquee.querySelector(".bobby-page__details-track");
    const originalSlides = Array.from(
      track?.querySelectorAll(".bobby-page__detail-slide") || [],
    );

    if (!track || originalSlides.length < 2 || !window.gsap) return null;

    const clonedSlides = originalSlides.map((slide) => {
      slide.querySelectorAll("img").forEach((image) => {
        image.draggable = false;
      });

      const clone = slide.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.querySelectorAll("img").forEach((image) => {
        image.draggable = false;
      });
      track.append(clone);
      return clone;
    });

    let marqueeTween = null;
    let speedTween = null;
    let isHovered = false;

    function buildMarquee() {
      speedTween?.kill();
      marqueeTween?.kill();
      window.gsap.set(track, { x: 0 });

      const cycleWidth =
        clonedSlides[0].getBoundingClientRect().left -
        originalSlides[0].getBoundingClientRect().left;

      if (cycleWidth <= 0) return;

      marqueeTween = window.gsap.to(track, {
        x: -cycleWidth,
        duration: cycleWidth / 70,
        ease: "none",
        repeat: -1,
      });
      marqueeTween.timeScale(isHovered ? 0.35 : 1);
    }

    function setMarqueeSpeed(timeScale) {
      if (!marqueeTween) return;
      speedTween?.kill();
      speedTween = window.gsap.to(marqueeTween, {
        timeScale,
        duration: 0.4,
        ease: "power1.out",
        overwrite: true,
      });
    }

    marquee.addEventListener(
      "mouseenter",
      () => {
        isHovered = true;
        setMarqueeSpeed(0.35);
      },
      { signal: abortSignal },
    );
    marquee.addEventListener(
      "mouseleave",
      () => {
        isHovered = false;
        setMarqueeSpeed(1);
      },
      { signal: abortSignal },
    );
    marquee.addEventListener("dragstart", (event) => event.preventDefault(), {
      signal: abortSignal,
    });

    window.requestAnimationFrame(buildMarquee);

    return {
      refresh: buildMarquee,
      destroy() {
        speedTween?.kill();
        marqueeTween?.kill();
        clonedSlides.forEach((slide) => slide.remove());
        window.gsap.set(track, { clearProps: "transform" });
      },
    };
  }

  function initDetailsMarquee(root, abortSignal) {
    const marquee = root.querySelector(
      ".bobby-page__details [data-bobby-marquee]",
    );
    return marquee ? createDetailsMarquee(marquee, abortSignal) : null;
  }

  /* ========================================================================
   * Small Details Section - End
   * ======================================================================== */

  /* ========================================================================
   * Package Section - Start
   * Static visual section; no runtime behavior is required.
   * ======================================================================== */
  /* Package Section - End ================================================== */

  /* ========================================================================
   * Page Lifecycle - Start
   * Supports initial rendering and Shopify Theme Editor section events.
   * ======================================================================== */

  function initBobbyPage(root) {
    if (!root || bobbyPageInstances.has(root)) return;

    const controller = new AbortController();
    const carousels = [
      initToughMarquee(root, controller.signal),
      initMobileFeatureCarousel(root, controller.signal),
      initDetailsMarquee(root, controller.signal),
    ].filter(Boolean);

    const refreshCarousels = () => {
      carousels.forEach((carousel) => carousel.refresh());
    };

    mobileMedia.addEventListener("change", refreshCarousels, {
      signal: controller.signal,
    });
    window.addEventListener("resize", refreshCarousels, {
      passive: true,
      signal: controller.signal,
    });

    bobbyPageInstances.set(root, {
      destroy() {
        controller.abort();
        carousels.forEach((carousel) => carousel.destroy());
        bobbyPageInstances.delete(root);
      },
    });
  }

  function destroyBobbyPage(root) {
    bobbyPageInstances.get(root)?.destroy();
  }

  function initAllBobbyPages(scope) {
    scope.querySelectorAll("[data-bobby-page]").forEach(initBobbyPage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllBobbyPages(document), {
      once: true,
    });
  } else {
    initAllBobbyPages(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAllBobbyPages(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("[data-bobby-page]").forEach(destroyBobbyPage);
  });

  /* ========================================================================
   * Page Lifecycle - End
   * ======================================================================== */
})();
